module.exports = __webpack_public_path__ + "img/glamping_6.0f971784.jpg";